import { Attributes } from '@singularsystems/neo-core';

export default class PortfolioIndicators {

    @Attributes.Date()
    public lastTradeDate: Date | null = null;

    // Client only properties / methods
}